import React from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

export const ReferralModal = ({
  text = "",
  onYes = null,
  onNo = null,
  show = true,
  yesLoading = false,
  noLoading = false,
}) => {
  return (
    <>
      {show ? (
        <div className="fade modal-backdrop show" style={{ zIndex: 1056 }}></div>
      ) : null}
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        centered
        style={{ zIndex: 1056 }}
      >
        <Modal.Body className="d-flex flex-column align-items-center">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/bonus.png"}
            width={50}
            alt=""
            className=" mb-3"
          />
          <h6 className="text-center">{text}</h6>
        </Modal.Body>
        <Modal.Footer className="d-block">
          <div className="row">
            <button
            className="btn btn-primary fw-semibold text-white w-100"
            disabled={yesLoading}
            onClick={onYes}
          >
            {yesLoading && <Spinner size="sm" className="text-white me-2" />}
            Copy Link
          </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
